export default "__VITE_ASSET__C3M91BVt__"